// Decreto 768 de 2022 writes risk classes as roman numerals (Clase I–V).
export const RISK_CLASS_ROMAN: Record<number, string> = {1: 'I', 2: 'II', 3: 'III', 4: 'IV', 5: 'V'}

export const RISK_CLASS_TONE: Record<number, 'green' | 'lime' | 'amber' | 'orange' | 'red'> = {
  1: 'green',
  2: 'lime',
  3: 'amber',
  4: 'orange',
  5: 'red',
}

export function formatRatePct(pct: number): string {
  return `${pct.toLocaleString('es-CO')} %`
}

const dateFmt = new Intl.DateTimeFormat('es-CO', {year: 'numeric', month: 'long', day: 'numeric'})

export function formatDate(iso: string): string {
  return dateFmt.format(new Date(iso))
}

// Anclado a Bogotá: un instante de bitácora legal se lee en hora colombiana en cualquier máquina
// (CI corre en UTC). Los formateadores de fecha-sin-hora parsean local a propósito.
const dateTimeFmt = new Intl.DateTimeFormat('es-CO', {
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'America/Bogota',
})

export function formatDateTime(iso: string): string {
  return dateTimeFmt.format(new Date(iso))
}

const instantDateFmt = new Intl.DateTimeFormat('es-CO', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'America/Bogota',
})

/** Fecha calendario de un instante, en Bogotá: `formatDateOnly(iso.slice(0, 10))` corta la fecha UTC
 * y una firma a las 20:30 de Bogotá saldría con la fecha de mañana. */
export function formatInstantDate(iso: string): string {
  return instantDateFmt.format(new Date(iso))
}

const instantShortDateFmt = new Intl.DateTimeFormat('es-CO', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timeZone: 'America/Bogota',
})

export function formatInstantShortDate(iso: string): string {
  return instantShortDateFmt.format(new Date(iso))
}

const shortDateFmt = new Intl.DateTimeFormat('es-CO', {year: 'numeric', month: 'short', day: '2-digit'})

/** Date-ONLY strings (YYYY-MM-DD) parsed as local, never via the Date
 * constructor (which reads them as UTC midnight and shifts a day in Bogotá). */
function parseDateOnly(isoDate: string): Date {
  const [year, month, day] = isoDate.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function formatDateOnly(isoDate: string): string {
  return dateFmt.format(parseDateOnly(isoDate))
}

export function formatShortDate(isoDate: string): string {
  return shortDateFmt.format(parseDateOnly(isoDate))
}

const monthFmt = new Intl.DateTimeFormat('es-CO', {month: 'long'})
const shortMonthFmt = new Intl.DateTimeFormat('es-CO', {month: 'short'})

export function formatMonthName(year: number, month: number): string {
  return monthFmt.format(new Date(year, month - 1, 1))
}

/** Sin el punto de «mar.»: en el eje de una gráfica cada carácter cuenta. */
export function formatShortMonth(year: number, month: number): string {
  return shortMonthFmt.format(new Date(year, month - 1, 1)).replace('.', '')
}

/** Local YYYY-MM-DD (en-CA formats that way), comparable against API date fields. */
export function localToday(): string {
  return new Intl.DateTimeFormat('en-CA').format(new Date())
}

/** Latest birth date still 18 today (Código Civil art. 34); mirrors the backend's `validate_fecha_nacimiento`. */
export function maxAdultBirthDate(): string {
  const today = new Date()
  return new Intl.DateTimeFormat('en-CA').format(new Date(today.getFullYear() - 18, today.getMonth(), today.getDate()))
}
